export const auctionPriceTypeDisplayValues = {
  0: 'marketplace.auction_price_type.unknown',
  1: 'marketplace.auction_price_type.asking_price',
  2: 'marketplace.auction_price_type.best_offer',
  3: 'marketplace.auction_price_type.to_be_decided',
  4: 'marketplace.auction_price_type.on_request',
  5: 'marketplace.auction_price_type.free',
  6: 'marketplace.auction_price_type.price_per_unit',
};
